module.exports = __webpack_public_path__ + "static/pe2-a32c537db84894a6e609ddbff20fce77.png";